import type { IconSvgObject } from './types';

const ChartMaximumIcon: IconSvgObject = [
  ["path", { d: "M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 17C19 10.3726 16.3137 5 13 5C9.68629 5 7 10.3726 7 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartMaximumIcon;
